import { NgModule } from "@angular/core";
import { LoginComponent } from "../login/login.component";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FloatLabelModule } from "primeng/floatlabel";
import { ImageModule } from "primeng/image";
import { CommonModule } from "@angular/common";
import { MessagesModule } from "../messages/messages.module";
import { TableModule } from "primeng/table";
import { ActionButtonComponent } from "../action-button/action-button.component";
import { BranchesComponent } from "../branch/branches/branches.component";
import { BranchDetailsComponent } from "../branch/branch-details/branch-details.component";
import { routes } from "../../app.routes";
import { MenuComponent } from "../menu/menu.component";
import { MobileMenuComponent } from "../mobile-menu/mobile-menu.component";
import { UsersComponent } from "../user/users/users.component";
import { UserDetailsComponent } from "../user/user-details/user-details.component";
import { DepartmentsComponent } from "../department/departaments/departments.component";
import { DepartmentsDetailsComponent } from "../department/departments-details/departments-details.component";

import { PriorityDetailsComponent } from "../priority/priority-details/priority-details.component";
import { PriorityListComponent } from "../priority/priority/priority.component";
import { StatusComponent } from "../status/status/status.component";
import { StatusDetailsComponent } from "../status/status-details/status-details.component";
import { CalendarModule } from "primeng/calendar";
import { TagsComponent } from "../tags/tags/tags.component";
import { TagsDetailsComponent } from "../tags/tags-details/tags-details.component";
import { TicketDetailsComponent } from "../ticket/ticket-details/ticket-details.component";
import { TicketComponent } from "../ticket/ticket/ticket.component";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { EditorModule } from "primeng/editor";
import { QuillModule } from "ngx-quill";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SingleChoiceComponent } from "../singlechoice/singlechoice/singlechoice.component";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ListHeaderComponent } from "./list-header/list-header.component";
import { DependentChoiceComponent } from "../dependent-choice/dependent-choice.component";
import { CommentsComponent } from "../comments/comments.component";
import { CommentsDetailsComponent } from "../comments-details/comments-details.component";
import { TaskComponent } from "../task/task.component";
import { TaskDetailsComponent } from "../task-details/task-details.component";
import { AccordionModule } from "primeng/accordion";
import { InvolvedComponent } from "../involved/involved/involved.component";

import { MediaListComponent } from "../media-list/media-list.component";
import { MediaDetailsComponent } from "../media-details/media-details.component";
import { HttpClientModule } from "@angular/common/http";
import { HeaderFiltersComponent } from "../filters/header-filters/header-filters.component";
import { FilterForTicketComponent } from "../filters/filter-for-ticket/filter-for-ticket/filter-for-ticket.component";
import { FilterButtonsComponent } from "../filters/filter-buttons/filter-buttons.component";
import { SelectedFiltersComponent } from "../filters/selected-filters/selected-filters.component";
import { FilterFormComponent } from "../filters/filters-forms/filter-form/filter-form.component";
import { ByIdFormComponent } from "../filters/filters-forms/by-id-form/by-id-form.component";
import { ByNewWestFormComponent } from "../filters/filters-forms/by-new-west-form/by-new-west-form.component";
import { ByTitleFormComponent } from "../filters/filters-forms/by-title-form/by-title-form.component";
import { ByStatusFormComponent } from "../filters/filters-forms/by-status-form/by-status-form.component";
import { ActiveFormComponent } from "../filters/filters-forms/active-form/active-form.component";
import { ArchivedFormComponent } from "../filters/filters-forms/archived-form/archived-form.component";
import { ByAssignedFormComponent } from "../filters/filters-forms/by-assigned-form/by-assigned-form.component";
import { ByBranchFormComponent } from "../filters/filters-forms/by-branch-form/by-branch-form.component";
import { ByPriorityFormComponent } from "../filters/filters-forms/by-priority-form/by-priority-form.component";
import { ByDepartmentFormComponent } from "../filters/filters-forms/by-department-form/by-department-form.component";
import { ByRegisteredFormComponent } from "../filters/filters-forms/by-registered-form/by-registered-form.component";
import { NotComponent } from "../filters/filters-forms/not/not.component";
import { InvolvedDetailsComponent } from "../involved/involved-details/involved-details.component";
import { MatTabsModule } from "@angular/material/tabs";
import { UserPassComponent } from "../user-pass/user-pass.component";
import { DepartmentUserDetailsComponent } from "../department/department-user-details/department-user-details.component";
import { DepartmentUserComponent } from "../department/department-user/department-user.component";
import { MultiActionComponent } from "../multi-action/multi-action.component";
import { ProcessingComponent } from "../multi-action/processing/processing.component";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "../reset-password/reset-password.component";
import { VersionsComponent } from "../versions/versions.component";
import { TicketTimelineComponent } from "../ticket-timeline/ticket-timeline.component";
import { DebugPanelComponent } from "../debug-panel/debug-panel.component";
import { InputSwitchModule } from "primeng/inputswitch";
import { SettingsPanelComponent } from "../settings-panel/settings-panel.component";
import { TicketRowComponent } from "../ticket/ticket-row/ticket-row.component";
import { TicketByBranchComponent } from "../ticket/ticket-by-branch/ticket-by-branch.component";
@NgModule({
  declarations: [
    LoginComponent,
    DependentChoiceComponent,
    InvolvedComponent,
    InvolvedDetailsComponent,
    ListHeaderComponent,
    ActionButtonComponent,
    DashboardComponent,
    BranchesComponent,
    BranchDetailsComponent,
    MenuComponent,
    MobileMenuComponent,
    UsersComponent,
    UserDetailsComponent,
    DepartmentsComponent,
    DepartmentsDetailsComponent,
    PriorityListComponent,
    PriorityDetailsComponent,
    StatusComponent,
    StatusDetailsComponent,
    TagsComponent,
    TagsDetailsComponent,
    TicketDetailsComponent,
    TicketComponent,
    SingleChoiceComponent,
    CommentsComponent,
    CommentsDetailsComponent,
    TaskComponent,
    TaskDetailsComponent,
    MediaListComponent,
    MediaDetailsComponent,
    HeaderFiltersComponent,
    FilterForTicketComponent,
    FilterButtonsComponent,
    SelectedFiltersComponent,
    FilterFormComponent,
    ByIdFormComponent,
    ByNewWestFormComponent,
    ByTitleFormComponent,
    ByStatusFormComponent,
    ActiveFormComponent,
    ArchivedFormComponent,
    ByAssignedFormComponent,
    ByBranchFormComponent,
    ByPriorityFormComponent,
    ByDepartmentFormComponent,
    ByRegisteredFormComponent,
    NotComponent,
    UserPassComponent,
    DepartmentUserDetailsComponent,
    DepartmentUserComponent,
    MultiActionComponent,
    ProcessingComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    VersionsComponent,
    TicketTimelineComponent,
    DebugPanelComponent,
    SettingsPanelComponent,
    TicketRowComponent,
    TicketByBranchComponent
  ],
  imports: [
    AutoCompleteModule,
    MatSelectModule,
    AccordionModule,
    MatOptionModule,
    MatDatepickerModule,
    QuillModule,
    CalendarModule,
    MatInputModule,
    MatIconModule,
    MatNativeDateModule,
    EditorModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    InputTextModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    TableModule,
    ButtonModule,
    BrowserAnimationsModule,
    CardModule,
    FormsModule,
    FloatLabelModule,
    ImageModule,
    ReactiveFormsModule,
    MessagesModule,
    QuillModule.forRoot(),
    RouterModule.forRoot(routes),
    HttpClientModule,
    MatTabsModule,
    InputSwitchModule,
  ],

  exports: [
    LoginComponent,
    RouterModule,
    TranslateModule,
    DashboardComponent,
    BranchesComponent,
    BranchDetailsComponent,
    MenuComponent,
    MobileMenuComponent,
    UsersComponent,
    UserDetailsComponent,
    DepartmentsComponent,
    DepartmentsDetailsComponent,
    PriorityListComponent,
    PriorityDetailsComponent,
    StatusComponent,
    StatusDetailsComponent,
    TagsComponent,
    TagsDetailsComponent,
    TicketDetailsComponent,
    TicketComponent,
    ListHeaderComponent,
    DependentChoiceComponent,
    CommentsComponent,
    CommentsDetailsComponent,
    TaskComponent,
    TaskDetailsComponent,
    InvolvedComponent,
    InvolvedDetailsComponent,
    MediaListComponent,
    MediaDetailsComponent,
    HeaderFiltersComponent,
    FilterForTicketComponent,
    FilterButtonsComponent,
    SelectedFiltersComponent,
    FilterFormComponent,
    ByIdFormComponent,
    ByTitleFormComponent,
    ByStatusFormComponent,
    ActiveFormComponent,
    ArchivedFormComponent,
    ByAssignedFormComponent,
    ByBranchFormComponent,
    ByPriorityFormComponent,
    ByDepartmentFormComponent,
    ByRegisteredFormComponent,
    NotComponent,
    UserPassComponent,
    DepartmentUserDetailsComponent,
    DepartmentUserComponent,
    MultiActionComponent,
    ProcessingComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    VersionsComponent,
    TicketTimelineComponent,
    DebugPanelComponent,
    SettingsPanelComponent,
    TicketRowComponent,
    TicketByBranchComponent
  ],
})
export class LoginModule {}
